export const SET = '/spotlight/set';
